function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useRef } from 'react';
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Image } from "../../Image/Image/Image";
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Link } from "../../Button/Link/Link";
import { Popup } from "../../Popup/Popup/Popup";
import { IconButton } from "../../Button/IconButton/IconButton";
import styles from "./SectionOneV2.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionOneV2 = function SectionOneV2(_ref) {
  var heading = _ref.heading,
    bodyText = _ref.bodyText,
    cards = _ref.cards;
  var popupComponentClinic = useRef(null);
  var popupComponentCore = useRef(null);
  var popupComponentArray = [popupComponentClinic, popupComponentCore];
  var togglePopup = function togglePopup(index) {
    var _popupComponentArray$, _popupComponentArray$2;
    (_popupComponentArray$ = popupComponentArray[index]) === null || _popupComponentArray$ === void 0 ? void 0 : (_popupComponentArray$2 = _popupComponentArray$.current) === null || _popupComponentArray$2 === void 0 ? void 0 : _popupComponentArray$2.togglePopup();
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.sectionOneV2,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [heading && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        align: "left",
        className: styles.heading,
        typog: heading.typog,
        ariaLevel: heading.ariaLevel,
        children: heading.text
      }), bodyText && /*#__PURE__*/_jsx(Text, {
        richText: true,
        align: "left",
        className: styles.text,
        typog: "bodycopyExtraLarge",
        children: bodyText
      }), /*#__PURE__*/_jsx("div", {
        className: styles.cards,
        children: cards === null || cards === void 0 ? void 0 : cards.map(function (card, index) {
          var _card$image, _card$offerBanner;
          return card.link.url ? /*#__PURE__*/_jsx(Link, {
            href: card.link.url,
            attributes: card.link.attributes,
            className: styles.inner,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.card,
              children: [((_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.mobile) && card.image.desktop && /*#__PURE__*/_jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/_jsxs(Breakpoint, {
                  breakpoint: "small",
                  children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                    className: styles.image
                  }, card.image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                    className: styles.image
                  }, card.image.desktop))]
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.cardContent,
                children: [card.heading && /*#__PURE__*/_jsx(HeadingText, {
                  richText: true,
                  align: "left",
                  className: styles.cardHeading,
                  typog: card.heading.typog,
                  ariaLevel: card.heading.ariaLevel,
                  children: card.heading.text
                }), card.bodyText && /*#__PURE__*/_jsxs("div", {
                  className: styles.offerTermsContainer,
                  children: [/*#__PURE__*/_jsx(Text, {
                    richText: true,
                    align: "left",
                    className: styles.cardText,
                    typog: "bodycopySmall",
                    children: card.bodyText
                  }), (card === null || card === void 0 ? void 0 : (_card$offerBanner = card.offerBanner) === null || _card$offerBanner === void 0 ? void 0 : _card$offerBanner.tooltipContent) && /*#__PURE__*/_jsx(Popup, {
                    ref: popupComponentArray[index],
                    handle: /*#__PURE__*/_jsx(IconButton, {
                      "aria-label": card.offerBanner.ariaLabel,
                      className: styles.tooltip,
                      icon: "info",
                      fill: '#808080',
                      size: "16px",
                      onClick: function onClick() {
                        return togglePopup(index);
                      }
                    }),
                    children: /*#__PURE__*/_jsx("div", {
                      className: styles.tooltipContent,
                      children: /*#__PURE__*/_jsx(Text, {
                        richText: true,
                        typog: "bodycopy",
                        children: card.offerBanner.tooltipContent
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.buttonWrapper,
                  children: card.button && /*#__PURE__*/_jsx(Button, _objectSpread({
                    className: styles.button
                  }, card.button))
                })]
              })]
            })
          }, "card-".concat(index)) : null;
        })
      })]
    })
  });
};